"use client";
var Ye = Object.defineProperty;
var Ve = (n, o, t) => o in n ? Ye(n, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[o] = t;
var V = (n, o, t) => Ve(n, typeof o != "symbol" ? o + "" : o, t);
import * as E from "react";
import { t as We, f as ue, c as ye, F as we, i as Ee, a as Ue, g as Xe, b as Be, h as ze } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { j as Pe, c as _, k as fe } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { c as Re, C as Ke } from "./useRenderElement-B8V3_e8R.mjs";
import { u as se } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as ee } from "./useEventCallback-CjuAhyNz.mjs";
import { u as U } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { v as _e } from "./visuallyHidden-DPuANzJJ.mjs";
import { u as Je, T as ke } from "./useTimeout-BRUciAq6.mjs";
import { f as H, i as Se, h as ae, e as J, c as W, g as ie } from "./element-DE7VsBMX.mjs";
import { u as Qe } from "./FloatingPortal-B6chGyBH.mjs";
import { u as Ze, a as et } from "./FloatingTree-vWe5pGqE.mjs";
import { j as oe } from "./jsx-runtime-CJ-St4mQ.mjs";
import { a as xe, g as Ie } from "./nodes-C8EyMHS3.mjs";
import { a as tt, b as nt, s as ot } from "./event-CXjJudzK.mjs";
import { u as rt } from "./useId-CFOlRH4L.mjs";
import { c as $e, d as st } from "./detectBrowser-CpuomNQW.mjs";
import { o as Q } from "./owner-DpSCkBia.mjs";
import { A as it } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { N as ct } from "./noop-CMWc2wUO.mjs";
let Te = 0;
function ce(n, o = {}) {
  const {
    preventScroll: t = !1,
    cancelPrevious: e = !0,
    sync: c = !1
  } = o;
  e && cancelAnimationFrame(Te);
  const r = () => n == null ? void 0 : n.focus({
    preventScroll: t
  });
  c ? r() : Te = requestAnimationFrame(r);
}
const X = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function Fe(n) {
  return n === "inert" ? X.inert : n === "aria-hidden" ? X["aria-hidden"] : X.none;
}
let te = /* @__PURE__ */ new WeakSet(), ne = {}, le = 0;
const je = (n) => n && (n.host || je(n.parentNode)), lt = (n, o) => o.map((t) => {
  if (n.contains(t))
    return t;
  const e = je(t);
  return n.contains(e) ? e : null;
}).filter((t) => t != null);
function at(n, o, t, e) {
  const c = "data-base-ui-inert", r = e ? "inert" : t ? "aria-hidden" : null, i = lt(o, n), k = /* @__PURE__ */ new Set(), g = new Set(i), R = [];
  ne[c] || (ne[c] = /* @__PURE__ */ new WeakMap());
  const v = ne[c];
  i.forEach(I), T(o), k.clear();
  function I(l) {
    !l || k.has(l) || (k.add(l), l.parentNode && I(l.parentNode));
  }
  function T(l) {
    !l || g.has(l) || [].forEach.call(l.children, (d) => {
      if (Pe(d) !== "script")
        if (k.has(d))
          T(d);
        else {
          const u = r ? d.getAttribute(r) : null, b = u !== null && u !== "false", y = Fe(r), B = (y.get(d) || 0) + 1, F = (v.get(d) || 0) + 1;
          y.set(d, B), v.set(d, F), R.push(d), B === 1 && b && te.add(d), F === 1 && d.setAttribute(c, ""), !b && r && d.setAttribute(r, r === "inert" ? "" : "true");
        }
    });
  }
  return le += 1, () => {
    R.forEach((l) => {
      const d = Fe(r), b = (d.get(l) || 0) - 1, y = (v.get(l) || 0) - 1;
      d.set(l, b), v.set(l, y), b || (!te.has(l) && r && l.removeAttribute(r), te.delete(l)), y || l.removeAttribute(c);
    }), le -= 1, le || (X.inert = /* @__PURE__ */ new WeakMap(), X["aria-hidden"] = /* @__PURE__ */ new WeakMap(), X.none = /* @__PURE__ */ new WeakMap(), te = /* @__PURE__ */ new WeakSet(), ne = {});
  };
}
function ut(n, o = !1, t = !1) {
  const e = H(n[0]).body;
  return at(n.concat(Array.from(e.querySelectorAll("[aria-live]"))), e, o, t);
}
const Ae = 20;
let q = [];
function de() {
  q = q.filter((n) => n.isConnected);
}
function ft(n) {
  de(), n && Pe(n) !== "body" && (q.push(n), q.length > Ae && (q = q.slice(-Ae)));
}
function Le() {
  return de(), q[q.length - 1];
}
function dt(n) {
  const o = ue();
  return Be(n, o) ? n : We(n, o)[0] || n;
}
function Oe(n, o) {
  var i;
  if (!o.current.includes("floating") && !((i = n.getAttribute("role")) != null && i.includes("dialog")))
    return;
  const t = ue(), c = ze(n, t).filter((k) => {
    const g = k.getAttribute("data-tabindex") || "";
    return Be(k, t) || k.hasAttribute("data-tabindex") && !g.startsWith("-");
  }), r = n.getAttribute("tabindex");
  o.current.includes("floating") || c.length === 0 ? r !== "0" && n.setAttribute("tabindex", "0") : (r !== "-1" || n.hasAttribute("data-tabindex") && n.getAttribute("data-tabindex") !== "-1") && (n.setAttribute("tabindex", "-1"), n.setAttribute("data-tabindex", "-1"));
}
function Ht(n) {
  const {
    context: o,
    children: t,
    disabled: e = !1,
    order: c = ["content"],
    initialFocus: r = 0,
    returnFocus: i = !0,
    restoreFocus: k = !1,
    modal: g = !0,
    closeOnFocusOut: R = !0,
    getInsideElements: v = () => []
  } = n, {
    open: I,
    onOpenChange: T,
    events: l,
    dataRef: d,
    elements: {
      domReference: u,
      floating: b
    }
  } = o, y = ee(() => {
    var a;
    return (a = d.current.floatingContext) == null ? void 0 : a.nodeId;
  }), B = ee(v), F = typeof r == "number" && r < 0, A = Se(u) && F, C = se(c), z = se(r), D = se(i), L = Ze(), s = Qe(), He = E.useRef(null), qe = E.useRef(null), M = E.useRef(!1), Z = E.useRef(!1), be = E.useRef(-1), me = Je(), re = s != null, m = ae(b), G = ee((a = m) => a ? We(a, ue()) : []), K = ee((a) => {
    const h = G(a);
    return C.current.map(() => h).filter(Boolean).flat();
  });
  E.useEffect(() => {
    if (e || !g)
      return;
    function a(p) {
      p.key === "Tab" && W(m, J(H(m))) && G().length === 0 && !A && ot(p);
    }
    const h = H(m);
    return h.addEventListener("keydown", a), () => {
      h.removeEventListener("keydown", a);
    };
  }, [e, u, m, g, C, A, G, K]), E.useEffect(() => {
    if (e || !b)
      return;
    function a(h) {
      const p = ie(h), x = G().indexOf(p);
      x !== -1 && (be.current = x);
    }
    return b.addEventListener("focusin", a), () => {
      b.removeEventListener("focusin", a);
    };
  }, [e, b, G]), E.useEffect(() => {
    if (e || !R)
      return;
    function a() {
      Z.current = !0;
    }
    function h(x) {
      const f = x.relatedTarget, O = x.currentTarget, N = ie(x);
      queueMicrotask(() => {
        const S = y(), Y = !(W(u, f) || W(b, f) || W(f, b) || W(s == null ? void 0 : s.portalNode, f) || f != null && f.hasAttribute(ye("focus-guard")) || L && (Ie(L.nodesRef.current, S).find(($) => {
          var P, j;
          return W((P = $.context) == null ? void 0 : P.elements.floating, f) || W((j = $.context) == null ? void 0 : j.elements.domReference, f);
        }) || xe(L.nodesRef.current, S).find(($) => {
          var P, j, ve;
          return [(P = $.context) == null ? void 0 : P.elements.floating, ae((j = $.context) == null ? void 0 : j.elements.floating)].includes(f) || ((ve = $.context) == null ? void 0 : ve.elements.domReference) === f;
        })));
        if (O === u && m && Oe(m, C), k && O !== u && !(N != null && N.isConnected) && J(H(m)) === H(m).body) {
          _(m) && m.focus();
          const $ = be.current, P = G(), j = P[$] || P[P.length - 1] || m;
          _(j) && j.focus();
        }
        if (d.current.insideReactTree) {
          d.current.insideReactTree = !1;
          return;
        }
        if (Z.current) {
          Z.current = !1;
          return;
        }
        (A || !g) && f && Y && // Fix React 18 Strict Mode returnFocus due to double rendering.
        f !== Le() && (M.current = !0, T(!1, x, "focus-out"));
      });
    }
    const p = !!(!L && s);
    function w() {
      d.current.insideReactTree = !0, me.start(0, () => {
        d.current.insideReactTree = !1;
      });
    }
    if (b && _(u))
      return u.addEventListener("focusout", h), u.addEventListener("pointerdown", a), b.addEventListener("focusout", h), p && b.addEventListener("focusout", w, !0), () => {
        u.removeEventListener("focusout", h), u.removeEventListener("pointerdown", a), b.removeEventListener("focusout", h), p && b.removeEventListener("focusout", w, !0);
      };
  }, [e, u, b, m, g, L, s, T, R, k, G, A, y, C, d, me]);
  const pe = E.useRef(null), he = E.useRef(null), De = Re(pe, s == null ? void 0 : s.beforeInsideRef), Ge = Re(he, s == null ? void 0 : s.afterInsideRef);
  E.useEffect(() => {
    var f, O, N;
    if (e || !b)
      return;
    const a = Array.from(((f = s == null ? void 0 : s.portalNode) == null ? void 0 : f.querySelectorAll(`[${ye("portal")}]`)) || []), p = (N = (O = (L ? xe(L.nodesRef.current, y()) : []).find((S) => {
      var Y;
      return Se(((Y = S.context) == null ? void 0 : Y.elements.domReference) || null);
    })) == null ? void 0 : O.context) == null ? void 0 : N.elements.domReference, w = [b, p, ...a, ...B(), He.current, qe.current, pe.current, he.current, s == null ? void 0 : s.beforeOutsideRef.current, s == null ? void 0 : s.afterOutsideRef.current, A ? u : null].filter((S) => S != null), x = ut(w, g || A);
    return () => {
      x();
    };
  }, [e, u, b, g, C, s, A, L, y, B]), U(() => {
    if (e || !_(m))
      return;
    const a = H(m), h = J(a);
    queueMicrotask(() => {
      const p = K(m), w = z.current, x = (typeof w == "number" ? p[w] : w.current) || m, f = W(m, h);
      !F && !f && I && ce(x, {
        preventScroll: x === m
      });
    });
  }, [e, I, m, F, K, z]), U(() => {
    if (e || !m)
      return;
    const a = H(m), h = J(a);
    ft(h);
    function p({
      reason: f,
      event: O,
      nested: N
    }) {
      if (["hover", "safe-polygon"].includes(f) && O.type === "mouseleave" && (M.current = !0), f === "outside-press")
        if (N)
          M.current = !1;
        else if (tt(O) || nt(O))
          M.current = !1;
        else {
          let S = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return S = !0, !1;
            }
          }), S ? M.current = !1 : M.current = !0;
        }
    }
    l.on("openchange", p);
    const w = a.createElement("span");
    w.setAttribute("tabindex", "-1"), w.setAttribute("aria-hidden", "true"), Object.assign(w.style, _e), re && u && u.insertAdjacentElement("afterend", w);
    function x() {
      if (typeof D.current == "boolean") {
        const f = u || Le();
        return f && f.isConnected ? f : w;
      }
      return D.current.current || w;
    }
    return () => {
      l.off("openchange", p);
      const f = J(a), O = W(b, f) || L && Ie(L.nodesRef.current, y(), !1).some((S) => {
        var Y;
        return W((Y = S.context) == null ? void 0 : Y.elements.floating, f);
      }), N = x();
      queueMicrotask(() => {
        const S = dt(N);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        D.current && !M.current && _(S) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(S !== f && f !== a.body) || O) && S.focus({
          preventScroll: !0
        }), w.remove();
      });
    };
  }, [e, b, m, D, d, l, L, re, u, y]), E.useEffect(() => {
    queueMicrotask(() => {
      M.current = !1;
    });
  }, [e]), E.useEffect(() => {
    if (e || !I)
      return;
    function a(p) {
      const w = ie(p);
      w != null && w.closest(`[${Ke}]`) && (Z.current = !0);
    }
    const h = H(m);
    return h.addEventListener("pointerdown", a, !0), () => {
      h.removeEventListener("pointerdown", a, !0);
    };
  }, [e, I, m]), U(() => {
    if (!e && s)
      return s.setFocusManagerState({
        modal: g,
        closeOnFocusOut: R,
        open: I,
        onOpenChange: T,
        domReference: u
      }), () => {
        s.setFocusManagerState(null);
      };
  }, [e, s, g, I, T, R, u]), U(() => {
    if (!(e || !m))
      return Oe(m, C), () => {
        queueMicrotask(de);
      };
  }, [e, m, C]);
  const ge = !e && (g ? !A : !0) && (re || g);
  return /* @__PURE__ */ oe.jsxs(E.Fragment, {
    children: [ge && /* @__PURE__ */ oe.jsx(we, {
      "data-type": "inside",
      ref: De,
      onFocus: (a) => {
        var h;
        if (g) {
          const p = K();
          ce(p[p.length - 1]);
        } else if (s != null && s.preserveTabOrder && s.portalNode)
          if (M.current = !1, Ee(a, s.portalNode)) {
            const p = Ue(u);
            p == null || p.focus();
          } else
            (h = s.beforeOutsideRef.current) == null || h.focus();
      }
    }), t, ge && /* @__PURE__ */ oe.jsx(we, {
      "data-type": "inside",
      ref: Ge,
      onFocus: (a) => {
        var h;
        if (g)
          ce(K()[0]);
        else if (s != null && s.preserveTabOrder && s.portalNode)
          if (R && (M.current = !0), Ee(a, s.portalNode)) {
            const p = Xe(u);
            p == null || p.focus();
          } else
            (h = s.afterOutsideRef.current) == null || h.focus();
      }
    })]
  });
}
const bt = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function qt(n, o = {}) {
  var b;
  const {
    open: t,
    elements: e,
    floatingId: c
  } = n, {
    enabled: r = !0,
    role: i = "dialog"
  } = o, k = rt(), g = ((b = e.domReference) == null ? void 0 : b.id) || k, R = E.useMemo(() => {
    var y;
    return ((y = ae(e.floating)) == null ? void 0 : y.id) || c;
  }, [e.floating, c]), v = bt.get(i) ?? i, T = et() != null, l = E.useMemo(() => v === "tooltip" || i === "label" ? {
    [`aria-${i === "label" ? "labelledby" : "describedby"}`]: t ? R : void 0
  } : {
    "aria-expanded": t ? "true" : "false",
    "aria-haspopup": v === "alertdialog" ? "dialog" : v,
    "aria-controls": t ? R : void 0,
    ...v === "listbox" && {
      role: "combobox"
    },
    ...v === "menu" && {
      id: g
    },
    ...v === "menu" && T && {
      role: "menuitem"
    },
    ...i === "select" && {
      "aria-autocomplete": "none"
    },
    ...i === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [v, R, T, t, g, i]), d = E.useMemo(() => {
    const y = {
      id: R,
      ...v && {
        role: v
      }
    };
    return v === "tooltip" || i === "label" ? y : {
      ...y,
      ...v === "menu" && {
        "aria-labelledby": g
      }
    };
  }, [v, R, g, i]), u = E.useCallback(({
    active: y,
    selected: B
  }) => {
    const F = {
      role: "option",
      ...y && {
        id: `${R}-fui-option`
      }
    };
    switch (i) {
      case "select":
      case "combobox":
        return {
          ...F,
          "aria-selected": B
        };
    }
    return {};
  }, [R, i]);
  return E.useMemo(() => r ? {
    reference: l,
    floating: d,
    item: u
  } : {}, [r, l, d, u]);
}
const mt = /* @__PURE__ */ E.forwardRef(function(o, t) {
  const {
    cutout: e,
    ...c
  } = o;
  let r;
  if (e) {
    const i = e == null ? void 0 : e.getBoundingClientRect();
    r = `polygon(
      0% 0%,
      100% 0%,
      100% 100%,
      0% 100%,
      0% 0%,
      ${i.left}px ${i.top}px,
      ${i.left}px ${i.bottom}px,
      ${i.right}px ${i.bottom}px,
      ${i.right}px ${i.top}px,
      ${i.left}px ${i.top}px
    )`;
  }
  return /* @__PURE__ */ oe.jsx("div", {
    ref: t,
    role: "presentation",
    "data-base-ui-inert": "",
    ...c,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: r
    }
  });
});
process.env.NODE_ENV !== "production" && (mt.displayName = "InternalBackdrop");
let Ce = {}, Me = {}, Ne = "";
function pt(n) {
  if (typeof document > "u")
    return !1;
  const o = Q(n);
  return fe(o).innerWidth - o.documentElement.clientWidth > 0;
}
function ht(n) {
  const t = Q(n).documentElement, e = t.style.overflow;
  return t.style.overflow = "hidden", () => {
    t.style.overflow = e;
  };
}
function gt(n) {
  var I;
  const o = Q(n), t = o.documentElement, e = o.body, c = fe(t);
  let r = 0, i = 0;
  const k = it.create();
  if ($e && (((I = c.visualViewport) == null ? void 0 : I.scale) ?? 1) !== 1)
    return () => {
    };
  function g() {
    var D;
    const T = c.getComputedStyle(t), l = c.getComputedStyle(e);
    r = t.scrollTop, i = t.scrollLeft, Ce = {
      scrollbarGutter: t.style.scrollbarGutter,
      overflowY: t.style.overflowY,
      overflowX: t.style.overflowX
    }, Ne = t.style.scrollBehavior, Me = {
      position: e.style.position,
      height: e.style.height,
      width: e.style.width,
      boxSizing: e.style.boxSizing,
      overflowY: e.style.overflowY,
      overflowX: e.style.overflowX,
      scrollBehavior: e.style.scrollBehavior
    };
    const d = typeof CSS < "u" && ((D = CSS.supports) == null ? void 0 : D.call(CSS, "scrollbar-gutter", "stable")), u = t.scrollHeight > t.clientHeight, b = t.scrollWidth > t.clientWidth, y = T.overflowY === "scroll" || l.overflowY === "scroll", B = T.overflowX === "scroll" || l.overflowX === "scroll", F = Math.max(0, c.innerWidth - t.clientWidth), A = Math.max(0, c.innerHeight - t.clientHeight), C = parseFloat(l.marginTop) + parseFloat(l.marginBottom), z = parseFloat(l.marginLeft) + parseFloat(l.marginRight);
    Object.assign(t.style, {
      scrollbarGutter: "stable",
      overflowY: !d && (u || y) ? "scroll" : "hidden",
      overflowX: !d && (b || B) ? "scroll" : "hidden"
    }), Object.assign(e.style, {
      position: "relative",
      height: C || A ? `calc(100dvh - ${C + A}px)` : "100dvh",
      width: z || F ? `calc(100vw - ${z + F}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), e.scrollTop = r, e.scrollLeft = i, t.setAttribute("data-base-ui-scroll-locked", ""), t.style.scrollBehavior = "unset";
  }
  function R() {
    Object.assign(t.style, Ce), Object.assign(e.style, Me), t.scrollTop = r, t.scrollLeft = i, t.removeAttribute("data-base-ui-scroll-locked"), t.style.scrollBehavior = Ne;
  }
  function v() {
    R(), k.request(g);
  }
  return g(), c.addEventListener("resize", v), () => {
    k.cancel(), R(), c.removeEventListener("resize", v);
  };
}
class vt {
  constructor() {
    V(this, "lockCount", 0);
    V(this, "restore", null);
    V(this, "timeoutLock", ke.create());
    V(this, "timeoutUnlock", ke.create());
    V(this, "release", () => {
      this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
    });
    V(this, "unlock", () => {
      var o;
      this.lockCount === 0 && this.restore && ((o = this.restore) == null || o.call(this), this.restore = null);
    });
  }
  acquire(o) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(o)), this.release;
  }
  lock(o) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const e = Q(o).documentElement, c = fe(e).getComputedStyle(e).overflowY;
    if (c === "hidden" || c === "clip") {
      this.restore = ct;
      return;
    }
    const r = st || !pt(o);
    this.restore = r ? ht(o) : gt(o);
  }
}
const yt = new vt();
function Dt(n) {
  const {
    enabled: o = !0,
    mounted: t,
    open: e,
    referenceElement: c = null
  } = n;
  U(() => {
    if (o && $e && t && !e) {
      const r = Q(c), i = r.body.style.userSelect, k = r.body.style.webkitUserSelect;
      return r.body.style.userSelect = "none", r.body.style.webkitUserSelect = "none", () => {
        r.body.style.userSelect = i, r.body.style.webkitUserSelect = k;
      };
    }
  }, [o, t, e, c]), U(() => {
    if (o)
      return yt.acquire(c);
  }, [o, c]);
}
export {
  Ht as F,
  mt as I,
  qt as a,
  ce as e,
  Dt as u
};
